import { render, staticRenderFns } from "./ServiceList.vue?vue&type=template&id=45f2ae2c&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=ts"
export * from "./ServiceList.vue?vue&type=script&lang=ts"
import style0 from "./ServiceList.vue?vue&type=style&index=0&id=45f2ae2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2ae2c",
  null
  
)

export default component.exports